
(function() {
  var result = { translations: { "es-mx": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min", "hours": "{{ hours }} h", "hoursAndMinutes": "{{ hours }} h {{ minutes }} min", "days": "{{ days }} d\xEDas", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "T{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "es-mx": "static-7.897"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.897",
    "ar-eg": "static-7.897",
    "bg": "static-7.897",
    "bn": "static-7.897",
    "ca-es": "static-7.897",
    "cs": "static-7.897",
    "da": "static-7.897",
    "de": "static-7.897",
    "el": "static-7.897",
    "en-gb": "static-7.897",
    "en": "static-7.897",
    "es-mx": "static-7.897",
    "es": "static-7.897",
    "fi": "static-7.897",
    "fr-ca": "static-7.897",
    "fr": "static-7.897",
    "he-il": "static-7.897",
    "hr": "static-7.897",
    "hu": "static-7.897",
    "id": "static-7.897",
    "it": "static-7.897",
    "ja": "static-7.897",
    "ko": "static-7.897",
    "lt": "static-7.897",
    "ms": "static-7.897",
    "nl": "static-7.897",
    "no": "static-7.897",
    "pl": "static-7.897",
    "pt-br": "static-7.897",
    "pt-pt": "static-7.897",
    "ro": "static-7.897",
    "ru": "static-7.897",
    "sk": "static-7.897",
    "sl": "static-7.897",
    "sv": "static-7.897",
    "th": "static-7.897",
    "tl": "static-7.897",
    "tr": "static-7.897",
    "uk": "static-7.897",
    "vi": "static-7.897",
    "x-pseudo": "static-7.897",
    "zh-cn": "static-7.897",
    "zh-hk": "static-7.897",
    "zh-tw": "static-7.897"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:es-mx', {version: 'static-7.897'}); }
})();


